import { gql } from '@/shared/graphql/generated/reporting';

export const getActiveStrategies = gql(/* GraphQL */ `
  query GetActiveStrategies {
    strategies: allTradingStrategySnapshots(
      orderBy: [TIMESTAMP_HOUR_DESC, CREATED_AT_BLOCK_TIMESTAMP_DESC]
      condition: { status: ACTIVE, isLatest: true }
    ) {
      nodes {
        ...StrategyInfo
      }
    }
  }
`);

export const getAllStrategyStats = gql(/* GraphQL */ `
  query GetAllStrategyStats(
    $startTime: Datetime!
    $endTime: Datetime!
    $ownerAccountSs58Id: String
  ) {
    stats: allTradingStrategySnapshots(
      filter: {
        timestampHour: { greaterThanOrEqualTo: $startTime, lessThanOrEqualTo: $endTime }
        ownerAccountSs58Id: { equalTo: $ownerAccountSs58Id }
      }
    ) {
      aggregates {
        sum {
          ...StrategyStats
        }
      }
    }
    closedStrategies: allTradingStrategySnapshots(
      orderBy: [TIMESTAMP_HOUR_DESC, CREATED_AT_BLOCK_TIMESTAMP_DESC]
      condition: { status: CLOSED, ownerAccountSs58Id: $ownerAccountSs58Id }
      first: 100
    ) {
      nodes {
        ...StrategyInfo
      }
    }
  }
`);

export const getStrategyTemplateDetails = gql(/* GraphQL */ `
  query getStrategyTemplateDetails(
    $baseAsset: ChainflipAsset!
    $quoteAsset: ChainflipAsset!
    $key: String!
    $type: StrategyType!
    $startTime: Datetime!
    $endTime: Datetime!
  ) {
    stats: allTradingStrategySnapshots(
      filter: {
        timestampHour: { greaterThanOrEqualTo: $startTime, lessThanOrEqualTo: $endTime }
        baseAsset: { equalTo: $baseAsset }
        quoteAsset: { equalTo: $quoteAsset }
        key: { equalTo: $key }
        type: { equalTo: $type }
      }
    ) {
      chartData: groupedAggregates(groupBy: [TIMESTAMP_HOUR]) {
        keys
        sum {
          ...StrategyChartData
        }
      }
      aggregates {
        sum {
          ...StrategyStats
        }
      }
    }
    strategies: allTradingStrategySnapshots(
      condition: { baseAsset: $baseAsset, quoteAsset: $quoteAsset, key: $key, type: $type }
      orderBy: [TIMESTAMP_HOUR_DESC]
    ) {
      nodes {
        ...StrategyInfo
      }
      totalCount
    }
  }
`);

gql(/* GraphQL */ `
  fragment StrategyInfo on TradingStrategySnapshot {
    id
    ownerAccountSs58Id
    strategyAccountSs58Id
    timestampHour
    totalLiquidity
    totalLiquidityValueUsd
    filledVolume
    filledVolumeValueUsd
    pnl
    pnlValueUsd
    pnl24Hour
    pnl24HourValueUsd
    apy7Days
    key
    type
    baseAsset
    quoteAsset
    baseLiquidity
    quoteLiquidity
    baseLiquidityValueUsd
    quoteLiquidityValueUsd
    createdAtBlockTimestamp
    closedAtBlockTimestamp
    status
    closedAtBlockId
    closedAtEventIndex
  }
`);
